import i18n from 'i18next';
import { LANGUAGE } from 'types';

export const setGlobalAppLanguage = async (language: LANGUAGE) => {
  i18n.changeLanguage(language);
};
